import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { UserGroupFilterEntity } from '../../domain/entities/UserGroupFilterEntity'

export class UserGroupFilterModel extends UserGroupFilterEntity {
  constructor(dataDto: UserGroupFilterEntity) {
    super()
    mapEntityProperties<UserGroupFilterModel>(this, dataDto)
  }
}
